import React, { useEffect, useState } from "react";

import "./Information-Card-Pc.scss";

//imports for user data
import { useSelector } from "react-redux";
import DonutPercentage from "./DonutPercentage";

const InformationCardPc = ({ percentage, Title,setTableToView }) => {
  

  const cardStyle = {
    backgroundColor: "#1e1e1e",
    padding: "20px",
    borderRadius: "15px",
    width: "100%",
    overflow: "hidden",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
    margin: "10px",
    color: "#ffffff",
    display: "flex",
  };

  const headerStyle = {
    margin: 0,
    fontSize: "1.3em",
  };

  const subHeaderStyle = {
    color: "#bbbbbb",
    fontSize: "0.9em",
    marginBottom: "20px",
  };

  const circleContainerStyle = {
    textAlign: "center",
    marginTop: "20px",
    position: "relative",
  };

  const circleStyle = {
    width: "100px",
    height: "100px",
    borderRadius: "50%",

    position: "relative",
    margin: "0px",
  };
  const circleBeforeStyle = {
    content: '""',
    width: "90px", // Adjust this value to change the size of the donut hole
    height: "90px",
    borderRadius: "50%",
    backgroundColor: "white", // Match the background of the card
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const amountStyle = {
    fontSize: "18px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
    position: "relative",
    zIndex: 1,
  };

  const percentageStyle = {
    color: "#293947 ",
    fontSize: "0.85em",
    marginTop: "5px",
    position: "relative",
    zIndex: 1,
  };

  const categoryListStyle = {
    marginTop: "20px",
    marginLeft: "10px",
  };

  const categoryStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "5px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
  };

  const dotStyle = {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginRight: "0px",
  };

  const labelStyle = {
    flexGrow: 1,
    marginLeft: "10px",
    fontFamily: "Karla, sans-serif",
    fontWeight: "700!important",
    textAlign: "left",
  };

  const valueStyle = {
    fontWeight: "bold",
    marginLeft: "10px",
    color: "#9D9D9D",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "400",
  };

  const buttonStyle = {
    backgroundColor: "transparent",
    border: "1px solid #9D9D9D",
    color: "black",
    fontSize: "12px",
    padding: "3px 5px",
    borderRadius: "5px",
    fontFamily: "Poppins, sans-serif",
    width: "100%",
    cursor: "pointer",
    transition: "background-color 0.3s",
    transition: "color 0.3s",
  };

  const buttonHoverStyle = {
    backgroundColor: "#333",
  };

  return (
    <div className="individual-card">
      <button
        style={{
          margin: 0,
          padding: "10px 20px",
          background: "none",
          border: "none",
          cursor:setTableToView?"pointer":"default",
          width: "100%",
        }}
        onClick={() => {
          if (setTableToView) {
            setTableToView(Title);
          }
         
        }}
      >
        <div className="top-half">
          <div className="title-and-date">
            <div className="title">{Title}</div>
            <div className="date">Data from 10/9/2018</div>
          </div>
          <div className="right-half"></div>
        </div>
        <div className="bottom-half">
          <div style={circleContainerStyle}>
            <DonutPercentage percentage={percentage} />
          </div>
          {/* list of categories */}
          <div style={categoryListStyle}>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#B99963" }}></span>
              <span style={{ ...labelStyle, color: "#B99963" }}>0-25%</span>
              {/* <span style={valueStyle}>%</span> */}
            </div>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#64A371" }}></span>
              <span style={{ ...labelStyle, color: "#64A371" }}>26-50%</span>
              {/* <span style={valueStyle}></span> */}
            </div>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#377771" }}></span>
              <span style={{ ...labelStyle, color: "#377771" }}>51-75%</span>
              {/* <span style={valueStyle}>%</span> */}
            </div>
            <div style={categoryStyle}>
              <span style={{ ...dotStyle, backgroundColor: "#293947 " }}></span>
              <span style={{ ...labelStyle, color: "#293947 " }}>76-100%</span>
              {/* <span style={valueStyle}>%</span> */}
            </div>
            {/* {cardData?.fields?.[3] && <>
             
            </>} */}
          </div>
        </div>
      </button>

      {/* <div style={circleContainerStyle}>
                <div style={circleStyle}>
                    <div style={circleBeforeStyle}></div>
                    <span style={amountStyle}>$8,295</span>
                    <span style={percentageStyle}>↓ 2.1%</span>
                </div>
            </div> */}
    </div>
  );
};

export default InformationCardPc;
